<template>
<nav class="nav_center2" style="padding: 0; background: cadetblue">
    <ul style="list-style: none">
        <li :class="{ topmenuactive: activeTab === 'hethongcntthungyen' }" @click="changeTab('hethongcntthungyen')">
            <a id="urlhethongcntthungyen" href="vi/chuongtrinhtaitroxathidiem#hungyen/hethongcntthungyen" style="color: white;">{{ currentLanguage.header_text_hethongCNTT15 }}</a>
        </li>
        <li :class="{ topmenuactive: activeTab === 'Xanghiatru' }" @click="changeTab('Xanghiatru')">
            <a id="urlXanghiatru" href="vi/chuongtrinhtaitroxathidiem#hungyen/xanghiatru" style="color: white;">
                {{ currentLanguage.header_text_NghiaTru }}
            </a>
        </li>
        <li :class="{ topmenuactive: activeTab === 'Xaphungcong' }" @click="changeTab('Xaphungcong')">
            <a id="urlXaphungcong" href="vi/chuongtrinhtaitroxathidiem#hungyen/xaphungcong" style="color: white;">
                {{ currentLanguage.header_text_PhungCong }}
            </a>
        </li>
        <li :class="{ topmenuactive: activeTab === 'Xavangiang' }" @click="changeTab('Xavangiang')">
            <a id="urlXavangiang" href="vi/chuongtrinhtaitroxathidiem#hungyen/xavangiang" style="color: white;">
                {{ currentLanguage.header_text_VanGiang }}
            </a>
        </li>
        <li :class="{ topmenuactive: activeTab === 'Xanhuquynh' }" @click="changeTab('Xanhuquynh')">
            <a id="urlXanhuquynh" href="vi/chuongtrinhtaitroxathidiem#hungyen/xanhuquynh" style="color: white;">
                {{ currentLanguage.header_text_NhuQuynh }}
            </a>
        </li>
        <li :class="{ topmenuactive: activeTab === 'Xalacdao' }" @click="changeTab('Xalacdao')">
            <a id="urlXalacdao" href="vi/chuongtrinhtaitroxathidiem#hungyen/xalacdao" style="color: white;">
                {{ currentLanguage.header_text_LacDao }}
            </a>
        </li>
        <li :class="{ topmenuactive: activeTab === 'Xadaidong' }" @click="changeTab('Xadaidong')">
            <a id="urlXadaidong" href="vi/chuongtrinhtaitroxathidiem#hungyen/xadaidong" style="color: white;">
                {{ currentLanguage.header_text_DaiDong }}
            </a>
        </li>
        <li :class="{ topmenuactive: activeTab === 'Xahoanlong' }" @click="changeTab('Xahoanlong')">
            <a id="urlXahoanlong" href="vi/chuongtrinhtaitroxathidiem#hungyen/xahoanlong" style="color: white;">
                {{ currentLanguage.header_text_HoanLong }}
            </a>
        </li>
        <li :class="{ topmenuactive: activeTab === 'Xanguyenvanlinh' }" @click="changeTab('Xanguyenvanlinh')">
            <a id="urlXanguyenvanlinh" href="vi/chuongtrinhtaitroxathidiem#hungyen/xanguyenvanlinh" style="color: white;">
                {{ currentLanguage.header_text_NguyenVanLinh }}
            </a>
        </li>
        <li :class="{ topmenuactive: activeTab === 'Xayenmy' }" @click="changeTab('Xayenmy')">
            <a id="urlXayenmy" href="vi/chuongtrinhtaitroxathidiem#hungyen/xayenmy" style="color: white;">
                {{ currentLanguage.header_text_YenMy }}
            </a>
        </li>
        <li :class="{ topmenuactive: activeTab === 'Xaphamngulao' }" @click="changeTab('Xaphamngulao')">
            <a id="urlXaphamngulao" href="vi/chuongtrinhtaitroxathidiem#hungyen/xaphamngulao" style="color: white;">
                {{ currentLanguage.header_text_PhamNguLao }}
            </a>
        </li>
        <li :class="{ topmenuactive: activeTab === 'Xatienhai' }" @click="changeTab('Xatienhai')">
            <a id="urlXatienhai" href="vi/chuongtrinhtaitroxathidiem#hungyen/xatienhai" style="color: white;">
                {{ currentLanguage.header_text_TienHai }}
            </a>
        </li>
        <li :class="{ topmenuactive: activeTab === 'Xakienxuong' }" @click="changeTab('Xakienxuong')">
            <a id="urlXakienxuong" href="vi/chuongtrinhtaitroxathidiem#hungyen/xakienxuong" style="color: white;">
                {{ currentLanguage.header_text_KienXuong }}
            </a>
        </li>
        <li :class="{ topmenuactive: activeTab === 'Xadongchau' }" @click="changeTab('Xadongchau')">
            <a id="urlXadongchau" href="vi/chuongtrinhtaitroxathidiem#hungyen/xadongchau" style="color: white;">
                {{ currentLanguage.header_text_DongChau }}
            </a>
        </li>
        <li :class="{ topmenuactive: activeTab === 'Xadongtienhai' }" @click="changeTab('Xadongtienhai')">
            <a id="urlXadongtienhai" href="vi/chuongtrinhtaitroxathidiem#hungyen/xadongtienhai" style="color: white;">
                {{ currentLanguage.header_text_DongTienHai }}
            </a>
        </li>
        <li :class="{ topmenuactive: activeTab === 'Xanamthaininh' }" @click="changeTab('Xanamthaininh')">
            <a id="urlXanamthaininh" href="vi/chuongtrinhtaitroxathidiem#hungyen/xanamthaininh" style="color: white;">
                {{ currentLanguage.header_text_NamThaiNinh }}
            </a>
        </li>

    </ul>
</nav>

<div class="wrapper row3">
    <main class="hoc container-fluid clear bv p-0">

        <!-- Mỗi xã -->
        <div v-if="activeTab === 'hethongcntthungyen'" style="min-height: 500px" class="padding-top15">
            <div class="title-bai-viet" v-html="titleHtmlHethongcntthungyen"></div>
            <div v-html="contentHtmlHethongcntthungyen || 'Đang cập nhập...'"></div>
        </div>
        <div v-if="showXanghiatru" class="padding-top15">
            <div v-html="contentHtmlXanghiatru || 'Đang cập nhật...'"></div>
        </div>
        <div v-if="showXaphungcong" class="padding-top15">
            <div v-html="contentHtmlXaphungcong || 'Đang cập nhật...'"></div>
        </div>
        <div v-if="showXavangiang" class="padding-top15">
            <div v-html="contentHtmlXavangiang || 'Đang cập nhật...'"></div>
        </div>
        <div v-if="showXanhuquynh" class="padding-top15">
            <div v-html="contentHtmlXanhuquynh || 'Đang cập nhật...'"></div>
        </div>
        <div v-if="showXalacdao" class="padding-top15">
            <div v-html="contentHtmlXalacdao || 'Đang cập nhật...'"></div>
        </div>
        <div v-if="showXadaidong" class="padding-top15">
            <div v-html="contentHtmlXadaidong || 'Đang cập nhật...'"></div>
        </div>
        <div v-if="showXahoanlong" class="padding-top15">
            <div v-html="contentHtmlXahoanlong || 'Đang cập nhật...'"></div>
        </div>
        <div v-if="showXanguyenvanlinh" class="padding-top15">
            <div v-html="contentHtmlXanguyenvanlinh || 'Đang cập nhật...'"></div>
        </div>
        <div v-if="showXayenmy" class="padding-top15">
            <div v-html="contentHtmlXayenmy || 'Đang cập nhật...'"></div>
        </div>
        <div v-if="showXaphamngulao" class="padding-top15">
            <div v-html="contentHtmlXaphamngulao || 'Đang cập nhật...'"></div>
        </div>
        <div v-if="showXatienhai" class="padding-top15">
           <div v-html="contentHtmlXatienhai || 'Đang cập nhật...'"></div>    
        </div>
        <div v-if="showXakienxuong" class="padding-top15">
            <div v-html="contentHtmlXakienxuong || 'Đang cập nhật...'"></div>    
        </div>
        <div v-if="showXadongchau" class="padding-top15">
           <div v-html="contentHtmlXadongchau|| 'Đang cập nhật...'"></div>    
        </div>
        <div v-if="showXadongtienhai" class="padding-top15">
            <div v-html="contentHtmlXadongtienhai || 'Đang cập nhật...'"></div>
        </div>
        <div v-if="showXanamthaininh" class="padding-top15">
            <div v-html="contentHtmlXanamthaininh || 'Đang cập nhật...'"></div>
        </div>
    </main>
</div>
</template>

<script scoped>
import {
    languages
} from "@/components/languages";
import {
    apiChiTietBaiViet
} from "@/components/listService";
import axios from "axios";

export default {
    components: {

    },
    data() {
        return {
            activeTab: 'hethongcntthungyen',

            currentLanguage: languages.vi,
            lang: "",
            base64: "",
            base64Title: "",

            showXavangiang: false,
            showXanhuquynh: false,
            showXaphungcong: false,
            showCopilot: false,
            showGrok: false,
            showXalacdao: false,
            showManus: false,
            showXanghiatru: false,
            showXadaidong: false,
            showXahoanlong: false,
            showUngDungAI: false,
            showXanguyenvanlinh: false,
            showXayenmy: false,
            showXaphamngulao: false,
            showXatienhai: false,
            showXakienxuong: false,
            showXadongchau: false,
            showXadongtienhai: false,
            showXanamthaininh: false,
            showHethongcntthungyen: false,

            titleHtmlAITaiLopHoc: "",
            contentHtmlAITaiLopHoc: "",
            titleHtml: "",
            contentHtml: "",
            titleHtmlTruongTaiTro: "",
            contentHtmlTruongTaiTro: "",
            titleHtmlTH: "",
            contentHtmlTH: "",
            titleHtmlTHCS: "",
            contentHtmlTHCS: "",
            titleHtmlTHPT: "",
            contentHtmlTHPT: "",
            titleHtmlLienHe: "",
            contentHtmlLienHe: "",
            titleHtmlLienCap: "",
            contentHtmlLienCap: "",

            titleHtmlXanghiatru: "",
            titleHtmlXavangiang: "",
            titleHtmlXanhuquynh: "",
            titleHtmlXaphungcong: "",
            titleHtmlCopilot: "",
            titleHtmlGrok: "",
            titleHtmlXalacdao: "",
            titleHtmlXadaidong: "",
            titleHtmlXahoanlong: "",
            titleHtmlManus: "",
            titleHtmlUngDungAI: "",
            titleHtmlXanguyenvanlinh: "",
            titleHtmlXayenmy: "",
            titleHtmlXaphamngulao: "",
            titleHtmlXatienhai: "",
            titleHtmlXakienxuong: "",
            titleHtmlXadongchau: "",
            titleHtmlXadongtienhai: "",
            titleHtmlXanamthaininh: "",
            titleHtmlHethongcntthungyen: "",
            conttentHtmlHethongcntthungyen: "",

            contentHtmlXanghiatru: "",
            contentHtmlXavangiang: "",
            contentHtmlXanhuquynh: "",
            contentHtmlCopilot: "",
            contentHtmlXaphungcong: "",
            contentHtmlGrok: "",
            contentHtmlXalacdao: "",
            contentHtmlXadaidong: "",
            contentHtmlXahoanlong: "",
            contentHtmlManus: "",
            contentHtmlUngDungAI: "",
            contentHtmlXanguyenvanlinh: "",

            contentHtmlXayenmy: "",
            contentHtmlXaphamngulao: "",
            contentHtmlXatienhai: "",
            contentHtmlXakienxuong: "",
            contentHtmlXadongchau: "",
            contentHtmlXadongtienhai: "",
            contentHtmlXanamthaininh: "",

        };
    },
    mounted() {
        if (window.innerWidth <= 768) {
            this.isMenuVisible = false;
        } else {
            this.isMenuVisible = true;
        }
        if (!this.hasMounted) {
            this.hasMounted = true;
            this.lang = localStorage.getItem("languages") || "vi";
            // this.performPostRequest("1755075075179y5bWE", "Xavangiang", this.lang);
            document.getElementById("urlhethongcntthungyen").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#hungyen/hethongcntt");
            document.getElementById("urlXanghiatru").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#hungyen/xanghiatru");
            document.getElementById("urlXaphungcong").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#hungyen/xaphungcong");
            document.getElementById("urlXanhuquynh").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#hungyen/xanhuquynh");
            document.getElementById("urlXavangiang").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#hungyen/xavangiang");
            document.getElementById("urlXalacdao").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#hungyen/xalacdao");
            document.getElementById("urlXadaidong").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#hungyen/xadaidong");
            document.getElementById("urlXahoanlong").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#hungyen/xahoanlong");
            document.getElementById("urlXanguyenvanlinh").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#hungyen/xanguyenvanlinh");
            document.getElementById("urlXayenmy").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#hungyen/xayenmy");
            document.getElementById("urlXaphamngulao").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#hungyen/xaphamngulao");
            document.getElementById("urlXatienhai").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#hungyen/xatienhai");
            document.getElementById("urlXakienxuong").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#hungyen/xakienxuong");
            document.getElementById("urlXadongchau").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#hungyen/xadongchau");
            document.getElementById("urlXadongtienhai").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#hungyen/xadongtienhai");
            document.getElementById("urlXanamthaininh").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#hungyen/xanamthaininh");

            // document.getElementById("urlManus").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#hungyen/manus/");
            // document.getElementById("urlGrok").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#hungyen/grok/");
            // document.getElementById("urlCopilot").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#hungyen/copilot/");

            let fragmentTab = window.location.hash.substring(1);
            if (fragmentTab.endsWith("/")) {
                fragmentTab = fragmentTab.slice(0, -1);
            }
            console.log("fragmentTab " + fragmentTab);

            if (fragmentTab === "hungyen/xanghiatru") {
                this.changeTab("Xanghiatru");
            } else if (fragmentTab === "hungyen/xaphungcong") {
                this.changeTab("Xaphungcong");
            } else if (fragmentTab === "hungyen/xanhuquynh") {
                this.changeTab("Xanhuquynh");
            } else if (fragmentTab === "hungyen/xavangiang") {
                this.changeTab("Xavangiang");
            } else if (fragmentTab === "hungyen/copilot") {
                this.changeTab("Copilot");
            } else if (fragmentTab === "hungyen/grok") {
                this.changeTab("Grok");
            } else if (fragmentTab === "hungyen/xalacdao") {
                this.changeTab("Xalacdao");
            } else if (fragmentTab === "hungyen/manus") {
                this.changeTab("Manus");
            } else if (fragmentTab === "hungyen/xadaidong") {
                this.changeTab("Xadaidong");
            } else if (fragmentTab === "hungyen/xahoanlong") {
                this.changeTab("Xahoanlong");
            } else if (fragmentTab === "hungyen/xanguyenvanlinh") {
                this.changeTab("Xanguyenvanlinh");
            } else if (fragmentTab === "hungyen/xayenmy") {
                this.changeTab("Xayenmy");
            } else if (fragmentTab === "hungyen/xaphamngulao") {
                this.changeTab("Xaphamngulao");
            } else if (fragmentTab === "hungyen/xatienhai") {
                this.changeTab("Xatienhai");
            } else if (fragmentTab === "hungyen/xakienxuong") {
                this.changeTab("Xakienxuong");
            } else if (fragmentTab === "hungyen/xadongchau") {
                this.changeTab("Xadongchau");
            } else if (fragmentTab === "hungyen/xadongtienhai") {
                this.changeTab("Xadongtienhai");
            } else if (fragmentTab === "hungyen/xanamthaininh") {
                this.changeTab("Xanamthaininh");
            } else if (fragmentTab === "hungyen/hethongcntthungyen") {
                this.changeTab("hethongcntthungyen");
            } else {
                // Nếu không phù hợp với bất kỳ tab nào, mặc định hiển thị tab gioiThieu
                this.changeTab("hethongcntthungyen");
            }
        }
    },
    created() {
        const savedLanguage = localStorage.getItem("languages");
        if (savedLanguage && languages[savedLanguage]) {
            this.currentLanguage = languages[savedLanguage];
        }
    },
    methods: {
        changeLanguage(lang) {
            this.currentLanguage = languages[lang];
            localStorage.setItem("languages", lang);
            window.location.reload();
        },

        async performPostRequest(id, section) {
            this.lang = localStorage.getItem("languages") || "vi";

            try {
                // Thực hiện POST request
                const response = await axios.post(apiChiTietBaiViet, {
                    id: id,
                    langId: "0",
                });
                if (this.lang === "vi") {
                    this.base64 = response.data.result.content_vi;
                    this.base64Title = response.data.result.title_vi;
                } else if (this.lang === "en") {
                    this.base64 = response.data.result.content_en;
                    this.base64Title = response.data.result.title_en;
                } else if (this.lang === "cn") {
                    this.base64 = response.data.result.content_cn;
                    this.base64Title = response.data.result.title_cn;
                } else if (this.lang === "kr") {
                    this.base64 = response.data.result.content_kr;
                    this.base64Title = response.data.result.title_kr;
                }

                var title = atob(this.base64Title);
                var decodedString = atob(this.base64);

                // Store separately for each section
                if (section === "Xavangiang") {
                    this.titleHtmlXavangiang = decodeURIComponent(escape(title));
                    this.contentHtmlXavangiang = decodeURIComponent(escape(decodedString));
                } else if (section === "Xanhuquynh") {
                    this.titleHtmlXanhuquynh = decodeURIComponent(escape(title));
                    this.contentHtmlXanhuquynh = decodeURIComponent(escape(decodedString));
                } else if (section === "Xaphungcong") {
                    this.titleHtmlXaphungcong = decodeURIComponent(escape(title));
                    this.contentHtmlXaphungcong = decodeURIComponent(escape(decodedString));
                } else if (section === "Copilot") {
                    this.titleHtmlCopilot = decodeURIComponent(escape(title));
                    this.contentHtmlCopilot = decodeURIComponent(escape(decodedString));
                } else if (section === "Grok") {
                    this.titleHtmlGrok = decodeURIComponent(escape(title));
                    this.contentHtmlGrok = decodeURIComponent(escape(decodedString));
                } else if (section === "Xalacdao") {
                    this.titleHtmlXalacdao = decodeURIComponent(escape(title));
                    this.contentHtmlXalacdao = decodeURIComponent(escape(decodedString));
                } else if (section === "Manus") {
                    this.titleHtmlManus = decodeURIComponent(escape(title));
                    this.contentHtmlManus = decodeURIComponent(escape(decodedString));
                } else if (section === "Xanghiatru") {
                    this.titleHtmlXanghiatru = decodeURIComponent(escape(title));
                    this.contentHtmlXanghiatru = decodeURIComponent(escape(decodedString));
                } else if (section === "Xadaidong") {
                    this.titleHtmlXadaidong = decodeURIComponent(escape(title));
                    this.contentHtmlXadaidong = decodeURIComponent(escape(decodedString));
                } else if (section === "Xahoanlong") {
                    this.titleHtmlXahoanlong = decodeURIComponent(escape(title));
                    this.contentHtmlXahoanlong = decodeURIComponent(escape(decodedString));
                } else if (section === "UngDungAI") {
                    this.titleHtmlUngDungAI = decodeURIComponent(escape(title));
                    this.contentHtmlUngDungAI = decodeURIComponent(escape(decodedString));
                } else if (section === "Xanguyenvanlinh") {
                    this.titleHtmlXanguyenvanlinh = decodeURIComponent(escape(title));
                    this.contentHtmlXanguyenvanlinh = decodeURIComponent(escape(decodedString));
                } else if (section === "Xayenmy") {
                    this.titleHtmlXayenmy = decodeURIComponent(escape(title));
                    this.contentHtmlXayenmy = decodeURIComponent(escape(decodedString));
                } else if (section === "Xaphamngulao") {
                    this.titleHtmlXaphamngulao = decodeURIComponent(escape(title));
                    this.contentHtmlXaphamngulao = decodeURIComponent(escape(decodedString));
                } else if (section === "Xatienhai") {
                    this.titleHtmlXatienhai = decodeURIComponent(escape(title));
                    this.contentHtmlXatienhai = decodeURIComponent(escape(decodedString));
                } else if (section === "Xakienxuong") {
                    this.titleHtmlXakienxuong = decodeURIComponent(escape(title));
                    this.contentHtmlXakienxuong = decodeURIComponent(escape(decodedString));
                } else if (section === "Xadongchau") {
                    this.titleHtmlXadongchau = decodeURIComponent(escape(title));
                    this.contentHtmlXadongchau = decodeURIComponent(escape(decodedString));
                } else if (section === "Xadongtienhai") {
                    this.titleHtmlXadongtienhai = decodeURIComponent(escape(title));
                    this.contentHtmlXadongtienhai = decodeURIComponent(escape(decodedString));
                } else if (section === "Xanamthaininh") {
                    this.titleHtmlXanamthaininh = decodeURIComponent(escape(title));
                    this.contentHtmlXanamthaininh = decodeURIComponent(escape(decodedString));
                } else if (section === "hethongcntthungyen") {
                    this.titleHtmlHethongcntthungyen = decodeURIComponent(escape(title));
                    this.contentHtmlHethongcntthungyen = decodeURIComponent(escape(decodedString));

                }
            } catch (error) {
                console.error("Error:", error);
            }
        },
        changeTab(tab) {
            //   if (window.innerWidth <= 768) {
            //     this.isMenuVisible = false;
            //   }
            this.lang = localStorage.getItem("languages");
            const tabStates = {
                Xavangiang: false,
                Xanhuquynh: false,
                Xaphungcong: false,
                Copilot: false,
                ungDungAI: false,
                Xanghiatru: false,
                xalacdao: false,
                Grok: false,
                Manus: false,
                Xadaidong: false,
                Xahoanlong: false,
                Xanguyenvanlinh: false,
                Xayenmy: false,
                Xaphamngulao: false,
                Xatienhai: false,
                Xakienxuong: false,
                Xadongchau: false,
                Xadongtienhai: false,
                Xanamthaininh: false,
                hethongcntthungyen: false,
            };
            this.performPostRequest(this.getPostId(tab), tab, this.lang);
            tabStates[tab] = true;
            this.activeTab = tab;
            this.showXavangiang = tabStates.Xavangiang;
            this.showXanhuquynh = tabStates.Xanhuquynh;
            this.showXaphungcong = tabStates.Xaphungcong;
            this.showCopilot = tabStates.Copilot;
            this.showGrok = tabStates.Grok;
            this.showXalacdao = tabStates.Xalacdao;
            this.showManus = tabStates.Manus;
            this.showXanghiatru = tabStates.Xanghiatru;
            this.showXadaidong = tabStates.Xadaidong;
            this.showXahoanlong = tabStates.Xahoanlong;
            this.showUngDungAI = tabStates.UngDungAI;
            this.showXanguyenvanlinh = tabStates.Xanguyenvanlinh;
            this.showXayenmy = tabStates.Xayenmy;
            this.showXaphamngulao = tabStates.Xaphamngulao;
            this.showXatienhai = tabStates.Xatienhai;
            this.showXakienxuong = tabStates.Xakienxuong;
            this.showXadongchau = tabStates.Xadongchau;
            this.showXadongtienhai = tabStates.Xadongtienhai;

            this.showXanamthaininh = tabStates.Xanamthaininh;
            this.showHethongcntthungyen = tabStates.hethongcntthungyen;

        },
        getPostId(tab) {
            // Sử dụng một đối tượng để ánh xạ tab với id của bài viết tương ứng
            const postIdMap = {

                Xavangiang: "1758514918395YUipz",
                Xanhuquynh: "1758514943186d0kIo",
                Xaphungcong: "1757672265531yHvni",
                Copilot: "",
                Grok: "",
                Xalacdao: "17585149685307M9lS",
                Manus: "",
                Xanghiatru: "1757667402514YXZGb",
                Xadaidong: "1758536754451MPguP", // thay ID sau
                Xahoanlong: "1758536780436T8lmv", // thay ID sau  
                UngDungAI: "", // thay ID sau
                Xanguyenvanlinh: "1758536808002C1dCy", // thay ID sau
                Xayenmy: "1758536831705Enm1h", // thay ID sau
                Xaphamngulao: "1758536860074owvoa", // thay ID sau
                Xatienhai: "1758536886711YhwR1", //
                Xakienxuong: "1757684265938PIydw", // thay ID sau
                Xadongchau: "1758536914443q73bX", //
                Xadongtienhai: "1758536945928yn9vP", // thay ID sau
                Xanamthaininh: "1758277329688B32sO", // thay ID sau
                hethongcntthungyen: "1757648388361YMn2m",
            };

            return postIdMap[tab];
        },
    },
};
</script>

<style scoped>
.title-bai-viet {
    display: none;
}

.hiddentitle {
    display: none;
}
</style>
